<script setup lang="ts">
const props = defineProps({
    youtubeLink: {
        type: String,
        required: true,
    },
});
const otherPlatforms = [
    {
        name: "Apple",
        link: "https://podcasts.apple.com/us/podcast/spotlight-4-success/id1785946954",
    },
    {
        name: "Spotify",
        link: "https://open.spotify.com/show/0ennSjZ6MeuYnUjn8PzbE3",
    },
    {
        name: "iHeart",
        link: "https://www.iheart.com/podcast/269-spotlight-4-success-240047591/",
    },
    {
        name: "Amazon",
        link: "https://music.amazon.com/podcasts/1496b321-d48c-4038-a259-c527f8d09761",
    },
    {
        name: "Youtube",
        link: props.youtubeLink,
    },
];
</script>

<template>
    <div class="text-center">
        <span class="text-gray-600">Other Platforms:</span>
        <ul>
            <li
                v-for="platform in otherPlatforms"
                :key="platform.name"
                class="inline-block border-r px-1 leading-4 last:border-r-0"
            >
                <a :href="platform.link" target="_blank" class="block px-2 text-abc-blue hover:underline">{{
                    platform.name
                }}</a>
            </li>
        </ul>
    </div>
</template>

<style scoped></style>
